import React from "react"
import styled from "styled-components"
import { P } from "@motorata/base-ui.components.atoms.typography";

const Counters = ({ list }: {
  list: {
    count: string
    text: string
  }[]
}) => {
  return (
    <Wrapper>
      {list.map((el, index) => (
        <CounterWrapper key={index}>
          <Count>{el?.count}</Count>
          <P textAlign="center" small>
            {el?.text}
          </P>
        </CounterWrapper>
      ))}
    </Wrapper>
  )
}

export default Counters

const Count = styled.span`
  text-align: center;
  display: block;
  font-size: ${({ theme }) => theme.font.XXXL};
  line-height: ${({ theme }) => theme.font.XXXL};
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.color.primary};
  margin-bottom: ${({ theme }) => theme.space.XS};
`

const CounterWrapper = styled.div`
  width: 150px;
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > * {
    margin-bottom: ${({ theme }) => theme.space.S};
  }

  svg {
    color: ${({ theme }) => theme.color.primary};
  }
`
